import { ProductDescription } from '../components/ProductDescription';
import { useProductDescriptionService } from '../services/useProductDescriptionService';

export interface ProductDescriptionContainerProps {
  isDescriptionOpened: boolean;
  setIsDescriptionOpened: (bool: boolean) => void;
  intersectionObserverCallback?: (entry: IntersectionObserverEntry) => void;
  options?: IntersectionObserverInit;
  hide_toggle_buttons?: boolean;
  is_raffle?: boolean;
}

export const ProductDescriptionContainer: React.FC<React.PropsWithChildren<ProductDescriptionContainerProps>> = ({
  isDescriptionOpened,
  setIsDescriptionOpened,
  intersectionObserverCallback,
  options,
  hide_toggle_buttons,
  is_raffle,
}) => {
  const service = useProductDescriptionService({
    isDescriptionOpened,
    setIsDescriptionOpened,
    intersectionObserverCallback,
    options,
  });

  return (
    <div ref={service.productVisibleIntersectRef}>
      <ProductDescription
        {...service}
        initialState={isDescriptionOpened}
        hide_toggle_buttons={hide_toggle_buttons}
        is_raffle={is_raffle}
      />
    </div>
  );
};
